











// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseFlux from '@/components/flux/edit/EditBaseFlux.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import * as rules from '@/utils/validationRules'
import { toSubArray, toNumberDictionary, toNumberLookup } from '@/utils/groupBy'
import { AloBase } from '@/models/alo/AloBase'
import { ExportCatalogType } from '@/enum/ExportCatalogType'

@Component({
  name: 'EditMetas',    
  components:{EditBaseFlux},
  props:{
    catalogueType:{
      type:String,
      required:true
    }
  }

})
export default class EditMetas extends Vue {
  
  private flux = getDefaultAloFlux()  
  private catalogueType!:ExportCatalogType

  ruleRequired(v:string) {    
    return rules.ruleRequired(v)
  }

  edit(item:AloFlux) {                    
    this.flux =  (this.$refs.baseEdit as EditBaseFlux).edit(item)              
  }

  get curEnsId(){
    return this.$store.myGetters.userProfile.ensId || 0
  } 

  private get title() {
    return this.catalogueType == ExportCatalogType.Offers?"Exporter un feed produit":"Exporter un feed famille"
  }

  get metaGroups() {        
    return this.$store.myGetters.metaGroups
  }

  get groupList() { 
    return this.$store.myGetters.metaGroupsList.filter(g => !!this.metasByGroup[g.id])
  }

  get metasList(){
    return this.$store.myGetters.metasList.filter(m => m.enseignesIds.some(ensId => this.curEnsId == ensId)).sort((m1,m2)=> {
      const  poids = (m1?.mtaPos ?? 0) - (m2?.mtaPos ?? 0)
      if(poids == 0){
        return m1.mtaKey.localeCompare(m2.mtaKey)
      }
      return poids
    })
  }

  get metasByGroup(){
    return toNumberLookup(this.metasList.filter(m => m.mtaFluxTyp == this.catalogueType),m=>m.mtgId)
  }
  
}
